import type { JSX } from 'react';
import type { UseFormRegister, FieldErrors } from 'react-hook-form';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export interface VerificationFormData {
  refereeEmail: string;
  refereeName: string;
  refereeJobTitle: string;
}

interface VerificationFormFieldsProps {
  register: UseFormRegister<VerificationFormData>;
  errors: FieldErrors<VerificationFormData>;
  variant?: 'referee' | 'contact';
}

const COPY = {
  referee: {
    nameLabel: 'Reference contact name *',
    nameRequired: 'Reference contact name is required',
    emailLabel: 'Reference contact email *',
    emailRequired: 'Reference contact email is required',
    jobTitleLabel: 'Reference contact job title',
  },
  contact: {
    nameLabel: 'Full name*',
    nameRequired: 'Full name is required',
    emailLabel: 'Email address*',
    emailRequired: 'Email address is required',
    jobTitleLabel: 'Job title',
  },
} as const;

export function VerificationFormFields({
  register,
  errors,
  variant = 'referee',
}: VerificationFormFieldsProps): JSX.Element {
  const copy = COPY[variant];
  return (
    <div className="space-y-4">
      <div className="space-y-2">
        <Label htmlFor="refereeName">{copy.nameLabel}</Label>
        <Input id="refereeName" {...register('refereeName', { required: copy.nameRequired })} />
        {errors.refereeName && (
          <p className="text-sm text-destructive">{errors.refereeName.message}</p>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="refereeEmail">{copy.emailLabel}</Label>
        <Input
          id="refereeEmail"
          type="email"
          {...register('refereeEmail', {
            required: copy.emailRequired,
            pattern: { value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/, message: 'Invalid email format' },
          })}
        />
        {errors.refereeEmail && (
          <p className="text-sm text-destructive">{errors.refereeEmail.message}</p>
        )}
      </div>

      <div className="space-y-2">
        <Label htmlFor="refereeJobTitle">{copy.jobTitleLabel}</Label>
        <Input id="refereeJobTitle" {...register('refereeJobTitle')} />
      </div>
    </div>
  );
}
